export const GMAIL = 'GMAIL'
export const OUTLOOK = 'OUTLOOK'

export const __dictionary = {
  [GMAIL]: {
    id: GMAIL,
    nombre: 'GMAIL'
  },
  [OUTLOOK]: {
    id: OUTLOOK,
    nombre: 'OUTLOOK'
  }
}

export const __array = [__dictionary[GMAIL], __dictionary[OUTLOOK]]
